module.exports = new __parcel__URL__("phone2.a7f6d401.jpg").toString();